// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__AddTransferRequest__buttonFooter{margin-top:20px}.app__AddTransferRequest__gwRowLayout{margin-bottom:50px}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/ent-capability-policyportfolio-react/component/AddTransferRequest/AddTransferRequest.module.scss"],"names":[],"mappings":"AAAE,uCACE,eAAA,CAGF,sCACE,kBAAA","sourcesContent":["  .buttonFooter {\n    margin-top: 20px;\n  }\n\n  .gwRowLayout {\n    margin-bottom: 50px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonFooter": "app__AddTransferRequest__buttonFooter",
	"gwRowLayout": "app__AddTransferRequest__gwRowLayout"
};
export default ___CSS_LOADER_EXPORT___;
